module.exports = __webpack_public_path__ + "img/purple-3-oval-striped.96997cd7.svg";